import { useApiRoutesGetCollection } from '@r/api/generated/client.ts';
import { isOrvalErrorFromPath } from '@r/api/orval-error-helper.ts';
import { maintenanceCriticalQueryOptions } from '@r/lib/maintenance-critical-query.ts';

const APP_ID: string = import.meta.env.VITE_APP_ID;

export const useRoutes = () => {
  const accessToken = localStorage.getItem('token');

  const routesQuery = useApiRoutesGetCollection({
    query: {
      queryKey: ['availableRoutes'],
      staleTime: Number.POSITIVE_INFINITY,
      enabled: Boolean(accessToken),
      // 500 → retries puis page maintenance si session (app.tsx)
      ...maintenanceCriticalQueryOptions
    },
    request: { headers: { 'App-Id': APP_ID } }
  });

  // Si pas de token, ne bloque pas l'app mais n'indique pas de succès
  if (!accessToken) {
    return {
      data: [],
      isLoading: false,
      isError: false,
      isSuccess: false,
      error: undefined,
      query: routesQuery
    };
  }

  if (routesQuery.isError && isOrvalErrorFromPath(routesQuery.error, 'get', '/routes')) {
    const status = (
      routesQuery.error as { response?: { status?: number; data?: { message?: string } } }
    )?.response?.status;
    if (status === 403) {
      return {
        data: [],
        isLoading: false,
        isError: false,
        isSuccess: true,
        error: undefined,
        query: routesQuery
      };
    }
  }

  return {
    data: routesQuery.data,
    isLoading: routesQuery.isLoading,
    isError: routesQuery.isError,
    isSuccess: routesQuery.isSuccess,
    error: routesQuery.error,
    query: routesQuery
  };
};
